import React, { useState } from 'react';
import { axios } from '../../libs/axios';
import { useTranslation } from '../../i18n/I18nContext';
import logger from '../../utils/logger';

export function ClientVerifyFieldForm({
	clientId,
	projectId,
	field,
	locked,
	onVerified,
	variant = 'inline',
	attemptsLeft,
}) {
	const { t } = useTranslation();
	const [value, setValue] = useState('');
	const [error, setError] = useState('');
	const [submitting, setSubmitting] = useState(false);
	const [localAttemptsLeft, setLocalAttemptsLeft] = useState(attemptsLeft);

	const fieldLabel = field === 'email' ? t('project.email') : t('project.personalId');
	const isLocked = locked || localAttemptsLeft === 0;

	if (isLocked) {
		return (
			<p className="client-modal-verify-error client-modal-verify-locked">
				{t('project.fieldLockedContactSupport')}
			</p>
		);
	}

	const handleSubmit = async (e) => {
		e.preventDefault();
		setError('');
		if (!value.trim()) {
			setError(t('project.verifyFieldRequired'));
			return;
		}
		try {
			setSubmitting(true);
			const res = await axios.post(`/clients/${clientId}/verify-field`, {
				field,
				value: value.trim(),
				projectId,
			});
			if (res?.attempts_left != null) {
				setLocalAttemptsLeft(res.attempts_left);
			}
			if (res?.success) {
				setValue('');
				setError('');
				await onVerified?.();
				return;
			}
			if (res?.locked) {
				setLocalAttemptsLeft(0);
				setError(t('project.fieldLockedContactSupport'));
			} else {
				setError(t('project.verifyFieldMismatch'));
			}
		} catch (err) {
			logger.error('verify-field failed:', err);
			setError(t('project.verifyFieldFailed'));
		} finally {
			setSubmitting(false);
		}
	};

	const hintText = field === 'email'
		? t('project.verifyEmailHint')
		: t('project.verifyPidHint', { count: localAttemptsLeft ?? attemptsLeft ?? 3 });

	if (variant === 'panel') {
		return (
			<div className="client-modal-verify-panel">
				<p className="client-modal-verify-hint">{hintText}</p>
				<form className="client-modal-verify-row" onSubmit={handleSubmit}>
					<input
						type={field === 'email' ? 'email' : 'text'}
						value={value}
						onChange={(e) => {
							setValue(e.target.value);
							if (error) setError('');
						}}
						placeholder={field === 'email' ? t('project.verifyEmailPlaceholder') : t('project.verifyPidPlaceholder')}
						autoComplete="off"
						disabled={submitting}
					/>
					<button type="submit" className="button client-modal-verify-btn" disabled={submitting}>
						{submitting ? t('common.saving') : t('project.verifyField')}
					</button>
				</form>
				{error && <p className="client-modal-verify-error">{error}</p>}
			</div>
		);
	}

	return (
		<form className="sidebar-verify-form" onSubmit={handleSubmit}>
			<label>{field === 'email' ? t('project.emailHiddenPrompt') : t('project.pidHiddenPrompt')}</label>
			<div className="sidebar-verify-row">
				<input
					type={field === 'email' ? 'email' : 'text'}
					value={value}
					onChange={(e) => setValue(e.target.value)}
					placeholder={fieldLabel}
					autoComplete="off"
					disabled={submitting}
				/>
				<button type="submit" className="button" disabled={submitting}>
					{submitting ? t('common.saving') : t('project.verifyField')}
				</button>
			</div>
			{error && <p className="sidebar-verify-error">{error}</p>}
		</form>
	);
}
